"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var current_node_view_container_1 = __importDefault(require("../current-node-view/current-node-view.container"));

var editor_content_styles_1 = require("./editor-content.styles");

var parent_node_view_container_1 = __importDefault(require("../parent-node-view/parent-node-view.container"));

var action_preview_container_1 = __importDefault(require("../action-preview/action-preview.container"));

var current_node_keywords_editor_container_1 = __importDefault(require("../../common-components/current-node-keywords-editor/current-node-keywords-editor.container"));

var EditorContent = function EditorContent() {
  return react_1.default.createElement(editor_content_styles_1.StyledEditorContentWrapperDiv, null, react_1.default.createElement(editor_content_styles_1.StyledLeftSideDiv, null, react_1.default.createElement(editor_content_styles_1.StyledParentNodeViewWrapperDiv, null, react_1.default.createElement(parent_node_view_container_1.default, null)), react_1.default.createElement(editor_content_styles_1.StyledKeywordsEditorWrapperDiv, null, react_1.default.createElement(current_node_keywords_editor_container_1.default, null))), react_1.default.createElement(editor_content_styles_1.StyledCurrentEditContentDiv, null, react_1.default.createElement(current_node_view_container_1.default, null)), react_1.default.createElement(editor_content_styles_1.StyledActionPreviewWrapperDiv, null, react_1.default.createElement(action_preview_container_1.default, {
    scale: 0.5
  })));
};

exports.default = EditorContent;